import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project1Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        True World News was a web-based platform built to help readers access information free from
                        bias, sensationalism, and political framing. Each morning, an automated pipeline gathered top
                        headlines from major publications and used the ChatGPT API, guided by strict editorial
                        instructions, to rewrite them in a neutral, fact-preserving tone.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A scheduled cloud function that fetched top headlines from multiple sources every morning.</li>
                        <li>An AI rewriting step that stripped opinionated language while preserving facts, attributing sources where needed.</li>
                        <li>A distraction-free frontend where readers could browse summaries by topic and view links back to original sources.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The pipeline reliably produced daily, source-attributed summaries with no manual editorial
                        work, demonstrating that AI rewriting could meaningfully reduce emotional and political
                        framing without sacrificing factual accuracy.
                    </p>

                    <p className='text-muted mb-0'><i>Completed March 2025</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project1Card;
